import { jsxs, jsx } from "react/jsx-runtime";
import { useCallback } from "react";
import { Button } from "@perxis-auto/ui-kit/lib/components/Button";
import { Row, Col } from "@perxis-auto/ui-kit/lib/components/Grid";
import { Icon } from "@perxis-auto/ui-kit/lib/components/Icon";
function PairBlockButton({ icon, onClick, children }) {
  const handleClick = useCallback(
    (index) => (e) => {
      var _a;
      e.stopPropagation();
      (_a = onClick == null ? void 0 : onClick[index]) == null ? void 0 : _a.call(onClick, e);
    },
    [onClick]
  );
  return /* @__PURE__ */ jsxs(Row, { gutter: [0, 12], children: [
    /* @__PURE__ */ jsx(Col, { span: 24, children: /* @__PURE__ */ jsx(Button, { type: "primary", onClick: handleClick(0), block: true, icon: /* @__PURE__ */ jsx(Icon, { name: icon[0] }), children: children == null ? void 0 : children[0] }) }),
    /* @__PURE__ */ jsx(Col, { span: 24, children: /* @__PURE__ */ jsx(Button, { type: "ghost", onClick: handleClick(1), block: true, icon: /* @__PURE__ */ jsx(Icon, { name: icon[1] }), children: children == null ? void 0 : children[1] }) })
  ] });
}
export {
  PairBlockButton
};
